import constate from "constate";
import { useCallback, useState } from "react";

const EMPTY_ARRAY: (HTMLElement | React.Ref<HTMLElement>)[] = [];
const usePropagation = () => {
  const [refs, setRefs] = useState<(HTMLElement | React.Ref<HTMLElement>)[]>(EMPTY_ARRAY);

  const addPropagationElement = useCallback((ref: HTMLElement | React.Ref<HTMLElement>) => {
    setRefs((prevState) => (prevState.includes(ref) ? prevState : [...prevState, ref]));
  }, []);

  const removePropagationElement = useCallback((ref: HTMLElement | React.Ref<HTMLElement>) => {
    setRefs((prevState) => prevState.filter((item) => item !== ref));
  }, []);

  return { actions: { addPropagationElement, removePropagationElement }, state: { refs } };
};

export const [PropgationProvider, usePropagationContext] = constate(usePropagation);
